import { PortfolioTypeEnum } from "web_myplann/Infrastructure/Api/Api";

let baseUrl = "";

export const setRoutingBaseUrl = (url: string) => {
	baseUrl = url;
};

export const Routing = {
	ActivitiesFiltersCreated: {
		path: () => `${baseUrl}/activities/filters/created`,
	},
	ActivitiesFiltersType: {
		path: () => `${baseUrl}/activities/filters/type`,
	},
	ActivitiesFiltersDate: {
		path: () => `${baseUrl}/activities/filters/date`,
	},
	ActivitiesFilters: {
		path: () => `${baseUrl}/activities/filters`,
	},
	ActivitiesList: {
		path: () => `${baseUrl}/activities`,
	},
	ActivityDetail: {
		route: `${baseUrl}/activities/:id`,
		path: (id: string) => `${baseUrl}/activities/${id}`,
	},
	TaskDetail: {
		route: `${baseUrl}/tasks/:id`,
		path: (id: string) => `${baseUrl}/tasks/${id}`,
	},
	Portfolio: {
		PortfolioList: {
			path: () => `${baseUrl}/portfolio`,
		},
		PortfolioDetail: {
			route: `${baseUrl}/portfolio/:id`,
			path: (id: string, type = PortfolioTypeEnum.Portfolio) =>
				`${baseUrl}/portfolio/${id}?type=${type}`,
		},
		PortfolioDetailHistory: {
			route: `${baseUrl}/portfolio/:id/history/:index`,
			path: (id: number, index: number) =>
				`${baseUrl}/portfolio/${id}/history/${index}`,
		},
		FolderDetail: {
			route: `${baseUrl}/portfolio/folder/:tag`,
			path: (tag: string) => `${baseUrl}/portfolio/folder/${tag}`,
		},
	},
	Profile: {
		ProfileDetail: {
			path: () => `${baseUrl}/profile`,
		},
		PersonalDataAndAccounts: {
			path: () => `${baseUrl}/profile/personal-data-and-accounts`,
		},
		Addresses: {
			path: () => `${baseUrl}/profile/addresses`,
		},
		Paperwork: {
			path: () => `${baseUrl}/profile/paperwork`,
		},
		More: {
			path: () => `${baseUrl}/profile/more`,
		},
		Security: {
			path: () => `${baseUrl}/profile/security`,
		},
		Settings: {
			path: () => `${baseUrl}/profile/settings`,
		},
	},
	Dashboard: {
		path: () => "/dashboard",
	},
	Notifications: {
		path: () => `${baseUrl}/notifications`,
	},
	Finances: {
		Intro: {
			path: () => `${baseUrl}/finances/intro`,
		},
		Income: {
			path: () => `${baseUrl}/finances/income`,
		},
		Expenses: {
			path: () => `${baseUrl}/finances/expenses`,
		},
		Balance: {
			path: () => `${baseUrl}/finances/balance`,
		},
		Overview: {
			path: () => `${baseUrl}/finances/overview`,
		},
	},
	Goals: {
		GoalsList: {
			path: () => `${baseUrl}/goals`,
		},
		GoalFormCreate: {
			path: () => `${baseUrl}/goals/new`,
		},
		GoalFormEdit: {
			route: `${baseUrl}/goals/:id/edit`,
			path: (id: string) => `${baseUrl}/goals/${id}/edit`,
		},
	},
	DashboardDetail: {
		route: `${baseUrl}/dashboard/:type`,
		path: (type: string) => `${baseUrl}/dashboard/${type}`,
	},
	StandAlone: {
		path: () => "/myplann-portfolio-standalone/portfolio",
	},
} as const;
